class StoreCtrl {
  static state;
  static action;
  static dispatch;

  static setData(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.setData, payload: value });
  }

  static toggleCurrentPasswordEye() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.toggleCurrentPasswordEye });
  }
  static toggleNewPasswordEye() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.toggleNewPasswordEye });
  }
  static toggleConfirmPasswordEye() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.toggleConfirmPasswordEye });
  }
  static toggleDeletePasswordEye() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.toggleDeletePasswordEye });
  }
  static checkPasswordIsValid(field) {
    if (field === 'deletePassword') {
      return StoreCtrl.state[field].isDirty && !StoreCtrl.state[field].isValid;
    }

    if (StoreCtrl.state[field].value === '') {
      return false
    } else {
      return StoreCtrl.state[field].isDirty && !StoreCtrl.state[field].isValid;
    }
  }
  static changeName(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeName, payload: value });
  }
  static changeCurrentPassword(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeCurrentPassword, payload: value });
  }
  static changeNewPassword(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeNewPassword, payload: value });
  }
  static changeNewPasswordFocus(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeNewPasswordFocus, payload: value });
  }
  static changeNewPasswordBlur(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeNewPasswordBlur, payload: value });
  }

  static changeConfirmPassword(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeConfirmPassword, payload: value });
  }
  static changeConfirmPasswordFocus(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeConfirmPasswordFocus, payload: value });
  }
  static changeConfirmPasswordBlur(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeConfirmPasswordBlur, payload: value });
  }
  static changeDeletePassword(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeDeletePassword, payload: value });
  }
  static initDeletePassword() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.initDeletePassword });
  }
  static changeTwoFactor(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeTwoFactor, payload: value });
  }
  static changeLogoutTime(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeLogoutTime, payload: value });
  }
  static changeLoginPreference(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.changeLoginPreference, payload: value });
  }
  static clickOptInMarketingEmail(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.clickOptInMarketingEmail, payload: value });
  }
  static setCode(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.setCode, payload: value });
  }
  static setQRData(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.setQRData, payload: value });
  }
  static uploadFile(value) {
    StoreCtrl.dispatch({ type: StoreCtrl.action.uploadFile, payload: value });
  }
  static deleteImage() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.deleteImage });
  }
  static initPassword() {
    StoreCtrl.dispatch({ type: StoreCtrl.action.initPassword });
  }
}

export default StoreCtrl;